module.exports = __webpack_public_path__ + "static/media/YM55_3.6a2999bb.jpg";